const HCS_BASE = "http://localhost:3014/hcs";
const topicId = "0.0.9374184"


// Fetch topicId for a given partnerId (or userId if mapped 1:1)
export async function getTopicIdForPartner(partnerId) {
  const res = await makeApiCall(`https://stage-apiv2.myearth.id/partner-topic/${partnerId}`, 'GET', {
    'Content-Type': 'application/json'
  });
  return res?.topicId;
}

// Generic API call helper
async function makeApiCall(url, method, headers, body = null) {
  const requestOptions = { method, headers, redirect: 'follow' };
  if (body) requestOptions.body = JSON.stringify(body);

  try {
    const response = await fetch(url, requestOptions);
    const responseText = await response.text();
    let responseJson;
    try {
      responseJson = JSON.parse(responseText);
      console.log('this is audit respoonse:', responseJson)
    } catch {
      responseJson = null;
    }
    if (!response.ok) {
      console.error(`❌ API call to ${url} failed`);
      console.error(`➡️ Status: ${response.status}`);
      console.error(`➡️ Body: ${responseText}`);
      return null;
    }
    return responseJson || responseText;
  } catch (error) {
    console.error(`💥 Fetch exception for ${url}:`, error);
    return null;
  }
}

// HCS API helpers
export async function getHcsTopicId() {
  const res = await makeApiCall(`${HCS_BASE}/topicId`, 'GET', {});
  return res?.topicId;
}

export async function publishToHcs(messageObj) {
  return await makeApiCall(`${HCS_BASE}/publish`, 'POST', {
    'Content-Type': 'application/json'
  }, {
    topic: topicId,
    message: messageObj
  });
}


export async function retrieveMessagesFromHcs() {
  return await makeApiCall(`${HCS_BASE}/messages`, 'POST', {
    'Content-Type': 'application/json'
  }, { topicId: topicId });
}